/* eslint-disable react/prop-types */
import { Routes, Route } from "react-router";
import NotFound from "../../pages/notFound";
import DealsList from "../../pages/dealsList";
import DealDetail from "../../pages/dealDetail";
import DealsUpload from "../../pages/dealsUpload";
import Brokers from "../../pages/brokers";
import Approvals from "../../pages/approvals";
import PickLists from "../../pages/admin/pickLists";
import Entities from "../../pages/admin/entities";
import Operators from "../../pages/admin/operators";
import Aois from "../../pages/admin/aois";
import Landmen from "../../pages/admin/landmen";
import Feedback from "../../pages/feedback";
import Announcements from "../../pages/admin/announcements";
import MetadataAdmin from "../../pages/admin/metadata";
import Appearance from "../../pages/admin/appearance";
import Reports from "../../pages/reports";
import ReportView from "../../pages/reports/reportView";
import ReportBuild from "../../pages/reports/reportBuild";
import ReportSources from "../../pages/reports/reportSources";


const RouterSwitch = (props) => {
  const { darkMode } = props;
  return (
    <div className="content">
      <Routes>
        {/* Redesigned deals list driven by /api/broker_deals/deals + */}
        {/* /metadata. Row click navigates to /deals/{deal_key}. */}
        <Route path="/" element={<DealsList darkMode={darkMode} />} />
        <Route path="/deals/:dealKey" element={<DealDetail darkMode={darkMode} />} />
        <Route path="/brokers" element={<Brokers darkMode={darkMode} />} />
        {/* Upload: download the generated template, fill it, upload it back. */}
        {/* The old column-mapping wizard (/upload/mapping) was removed — the */}
        {/* template is the single intake path. */}
        <Route path="/upload" element={<DealsUpload darkMode={darkMode} />} />
        {/* Capex approval queue. Slice 1 ships the gated nav slot + */}
        {/* placeholder; the real queue lands next slice. The page */}
        {/* self-redirects when the user lacks approvalQueue.view. */}
        <Route path="/approvals" element={<Approvals darkMode={darkMode} />} />
        {/* Admin → Pick Lists — manage dropdown vocabularies. Gated to */}
        {/* BD.Admin; the page self-redirects when the user lacks */}
        {/* admin.pickLists. */}
        <Route path="/admin/pick-lists" element={<PickLists darkMode={darkMode} />} />
        {/* Broker Access is now folded into /brokers as a master/detail */}
        {/* "Agents" child panel (admin-gated). The standalone screen + its */}
        {/* /admin/broker-access route were removed. */}
        {/* Admin → Entities — manage the shared entity master (Buyer/Seller */}
        {/* vocabulary): add / rename / activate / deactivate (soft). Gated to */}
        {/* BD.Admin; the page self-redirects when the user lacks */}
        {/* admin.entities. */}
        <Route path="/admin/entities" element={<Entities darkMode={darkMode} />} />
        {/* Admin → Operators — manage the shared operator master (Well */}
        {/* operator vocabulary): add / rename / activate / deactivate (soft). */}
        {/* Gated to BD.Admin; the page self-redirects when the user lacks */}
        {/* admin.operators. */}
        <Route path="/admin/operators" element={<Operators darkMode={darkMode} />} />
        {/* Admin → AOIs — manage the Area-of-Interest master: add / rename / */}
        {/* set-clear the upstream prospect key / activate / deactivate */}
        {/* (soft). Gated to BD.Admin; the page self-redirects when the user */}
        {/* lacks admin.aois. */}
        <Route path="/admin/aois" element={<Aois darkMode={darkMode} />} />
        {/* Admin → Landmen — maintain the WIG land-team roster behind the */}
        {/* deal form's Warwick Landman picker: add / rename / set-clear the */}
        {/* email / activate / deactivate (soft — there is no hard delete). */}
        {/* Gated to BD.Admin; the page self-redirects when the user lacks */}
        {/* admin.landmen. */}
        <Route path="/admin/landmen" element={<Landmen darkMode={darkMode} />} />
        {/* Feedback — the bug / feature request queue. Deliberately NOT */}
        {/* under /admin and NOT role-gated: every user lands here to read */}
        {/* replies on what they filed, while a BD.Admin sees the whole */}
        {/* queue plus the triage controls. The server scopes the list, so */}
        {/* there is nothing for the page to redirect away from. */}
        {/* `?request=<id>` deep-links one ticket — that is the link_url the */}
        {/* notification bell carries. */}
        <Route path="/feedback" element={<Feedback darkMode={darkMode} />} />
        {/* Admin → Announcements — author planned-outage / maintenance */}
        {/* notices. Only WRITING is gated: every user reads announcements */}
        {/* through the banner, which needs no route. The page */}
        {/* self-redirects when the user is not an app-support admin. */}
        <Route
          path="/admin/announcements"
          element={<Announcements darkMode={darkMode} />}
        />
        {/* Admin → Field Settings — labels, number formats and field */}
        {/* visibility as data. Promoted from the template; this app is the */}
        {/* first adopter. Needs VITE_APP_API_BASE=/broker_deals. Gated the */}
        {/* same way: the page self-redirects, the server refuses anyway. */}
        <Route
          path="/admin/metadata"
          element={<MetadataAdmin darkMode={darkMode} />}
        />
        {/* Admin → Appearance — the app-wide look preset. Same gate: the */}
        {/* page self-redirects, the server refuses anyway. */}
        <Route
          path="/admin/appearance"
          element={<Appearance darkMode={darkMode} />}
        />
        {/* Reports (#239). List and viewer are open to every BD role (the */}
        {/* server scopes each widget's rows). The builder — new and edit — */}
        {/* is BD.Admin only: the page self-redirects without */}
        {/* reports.manage, and POST/PUT/DELETE /reports refuse anyway. */}
        <Route path="/reports" element={<Reports darkMode={darkMode} />} />
        <Route path="/reports/new" element={<ReportBuild darkMode={darkMode} />} />
        {/* Report sources: SQL report sources. BD.Admin only, same gate as */}
        {/* the builder (self-redirect; the server refuses anyway). Before */}
        {/* /reports/:id so "sources" is not read as a report id. */}
        <Route path="/reports/sources" element={<ReportSources darkMode={darkMode} />} />
        <Route path="/reports/:id" element={<ReportView darkMode={darkMode} />} />
        <Route path="/reports/:id/edit" element={<ReportBuild darkMode={darkMode} />} />
        <Route path="/not-found" element={<NotFound darkMode={darkMode} />} />
      </Routes>
    </div>
  );
};

export default RouterSwitch;
